import React from "react";
import Page, { PageProps } from "../Page";
import Header from "../../components/Header";
import { IPasswordResetPresenter } from "../../../presenter/authentication/PasswordResetPresenter";
import Title from "antd/es/typography/Title";
import Loader from "../../components/Loader";
import Text from "antd/lib/typography/Text";

export interface Props extends PageProps {}
export interface State extends IPasswordResetPresenter {}

export default class PasswordResetConfirmationPage extends React.Component<
  Props,
  State
> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    const { translate, loaders, confirmationMessage, confirmationSuccess } =
      this.state;

    return (
      <Page {...this.props}>
        <Header languagePickerVisible={false} />
        <Loader
          loading={loaders.confirmPasswordReset}
          children={
            <div className="reset-password-form-wrapper">
              <div className="reset-password-form-container">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column"
                  }}>
                  <Title
                    level={4}
                    style={{ margin: 0, padding: 0, marginBottom: 5 }}>
                    {translate("pages.confirm_password_reset")}
                  </Title>
                  <Text
                    className={
                      confirmationSuccess
                        ? "confirmation-success-message"
                        : "confirmation-error-message"
                    }
                    style={{ textAlign: "center" }}>
                    {confirmationMessage}
                  </Text>
                </div>
              </div>
            </div>
          }
        />
      </Page>
    );
  }
}
